import Vue from 'vue';
import Player from '@/services/player/Player';
import GeneralHands from '@/services/hands/GeneralHands';
import utilities from '@/services/utilities/utilities';
import _ from 'lodash';

export default {
  createSharableEquityCalculatorURL: function (storeState) {
    let data = this._constructEquityCalculatorData(storeState);

    return Vue.axios.post(`${process.env.BASE_API_URL}/create-sharable-url`, data);
  },
  createSharableHitCalculatorURL: function (storeState) {
    let data = this._constructHitCalculatorData(storeState);

    return Vue.axios.post(`${process.env.BASE_API_URL}/create-sharable-url`, data);
  },
  createSharableGuidedAnalysesBluffingURL: function (storeState) {
    let data = this._constructGuidedAnalysesBluffingData(storeState);

    return Vue.axios.post(`${process.env.BASE_API_URL}/create-sharable-url`, data);
  },
  createSharableGuidedAnalysesCallingURL: function (storeState) {
    let data = this._constructGuidedAnalysesCallingData(storeState);

    return Vue.axios.post(`${process.env.BASE_API_URL}/create-sharable-url`, data);
  },
  createSharableRangeConstructorURL: function (storeState) {
    let data = this._constructRangeConstructorData(storeState);

    return Vue.axios.post(`${process.env.BASE_API_URL}/create-sharable-url`, data);
  },
  createSharableEquityMatrixURL: function (storeState) {
    let data = this._constructEquityMatrixData(storeState);

    return Vue.axios.post(`${process.env.BASE_API_URL}/create-sharable-url`, data);
  },
  createSharableTurnBluffBreakevenPercentageURL: function (state) {
    let data = this._constructTurnBluffBreakevenPercentageData(state);

    return Vue.axios.post(`${process.env.BASE_API_URL}/create-sharable-url`, data);
  },
  createSharableThreeBetCbetExplorerURL: function (storeState) {
    let data = this._constructThreeBetCbetExplorerData(storeState);

    return Vue.axios.post(`${process.env.BASE_API_URL}/create-sharable-url`, data);
  },
  _constructEquityCalculatorData: function (storeState) {
    let players = [];

    storeState.players.forEach(function (playerFromStore) {
      players.push({
        equity: playerFromStore.states[0].equity,
        winPercentage: playerFromStore.states[0].winPercentage,
        tiePercentage: playerFromStore.states[0].tiePercentage,
        specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[0].generalHands),
        specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[0].generalHands),
        numberOfSpecificHandsInRange: playerFromStore.states[0].generalHands.numberOfSpecificHandsInRange,
        numberOfPossibleSpecificHands: playerFromStore.states[0].generalHands.numberOfPossibleSpecificHands,
      });
    }, this);

    return {
      type: 'equity-calculator',
      storeState: {
        presetCommunityCards: storeState.presetCommunityCards,
        players: players,
      },
    };
  },
  _constructHitCalculatorData: function (storeState) {
    let players = [];

    storeState.players.forEach(function (playerFromStore) {
      players.push({
        states: [{
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[0].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[0].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[0].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[0].generalHands.numberOfPossibleSpecificHands,
          equity: playerFromStore.states[0].equity,
          winPercentage: playerFromStore.states[0].winPercentage,
          tiePercentage: playerFromStore.states[0].tiePercentage,
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[1].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[1].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[1].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[1].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[1].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[1].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[1].fiveCardHands),
          equity: playerFromStore.states[1].equity,
          winPercentage: playerFromStore.states[1].winPercentage,
          tiePercentage: playerFromStore.states[1].tiePercentage,
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[2].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[2].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[2].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[2].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[2].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[2].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[2].fiveCardHands),
          equity: playerFromStore.states[2].equity,
          winPercentage: playerFromStore.states[2].winPercentage,
          tiePercentage: playerFromStore.states[2].tiePercentage,
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[3].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[3].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[3].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[3].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[3].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[3].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[3].fiveCardHands),
          equity: playerFromStore.states[3].equity,
          winPercentage: playerFromStore.states[3].winPercentage,
          tiePercentage: playerFromStore.states[3].tiePercentage,
        }],
      });
    }, this);

    return {
      type: 'hit-calculator',
      storeState: {
        presetHoleCards: storeState.presetHoleCards,
        presetCommunityCards: storeState.presetCommunityCards,
        players: players,
      },
    };
  },
  _constructGuidedAnalysesBluffingData: function (storeState) {
    let players = [];

    storeState.players.forEach(function (playerFromStore) {
      players.push({
        states: [{
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[0].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[0].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[0].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[0].generalHands.numberOfPossibleSpecificHands,
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[1].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[1].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[1].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[1].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[1].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[1].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[1].fiveCardHands),
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[2].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[2].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[2].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[2].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[2].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[2].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[2].fiveCardHands),
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[3].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[3].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[3].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[3].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[3].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[3].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[3].fiveCardHands),
        }],
      });
    }, this);

    return {
      type: 'guided-analyses/should-you-bluff',
      storeState: {
        presetHoleCards: storeState.presetHoleCards,
        presetCommunityCards: storeState.presetCommunityCards,
        players: players,
        streetToBluff: storeState.streetToBluff,
        bluffSize: storeState.bluffSize,
        profitableBreakevenPercentage: storeState.profitableBreakevenPercentage,
      },
    };
  },
  _constructGuidedAnalysesCallingData: function (storeState) {
    let players = [];

    storeState.players.forEach(function (playerFromStore) {
      players.push({
        states: [{
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[0].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[0].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[0].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[0].generalHands.numberOfPossibleSpecificHands,
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[1].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[1].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[1].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[1].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[1].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[1].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[1].fiveCardHands),
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[2].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[2].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[2].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[2].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[2].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[2].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[2].fiveCardHands),
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[3].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[3].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[3].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[3].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[3].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[3].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[3].fiveCardHands),
        }],
      });
    }, this);

    return {
      type: 'guided-analyses/should-you-call',
      storeState: {
        presetHoleCards: storeState.presetHoleCards,
        presetCommunityCards: storeState.presetCommunityCards,
        players: players,
        streetToCall: storeState.streetToCall,
        potOdds: storeState.potOdds,
        realOddsLHS: storeState.realOddsLHS,
        bettingCriteria: storeState.bettingCriteria,
      },
    };
  },
  _constructRangeConstructorData: function (storeState) {
    return {
      type: 'range-constructor',
      storeState: {
        generalHandStringColorMap: this.__getGeneralHandStringColorMap(storeState.generalHands),
        actions: storeState.actions,
      },
    };
  },
  _constructEquityMatrixData: function (storeState) {
    let players = [];
    let generalHandStringEquityMap;

    storeState.players.forEach(function (playerFromStore) {
      players.push({
        specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[0].generalHands),
        specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[0].generalHands),
        numberOfSpecificHandsInRange: playerFromStore.states[0].generalHands.numberOfSpecificHandsInRange,
        numberOfPossibleSpecificHands: playerFromStore.states[0].generalHands.numberOfPossibleSpecificHands,
      });
    }, this);
    generalHandStringEquityMap = this.__getGeneralHandStringEquityMap(storeState.resultGeneralHands);

    return {
      type: 'equity-matrix',
      storeState: {
        requiredEquity: storeState.requiredEquity,
        presetCommunityCards: storeState.presetCommunityCards,
        players: players,
        generalHandStringEquityMap: generalHandStringEquityMap,
      },
    };
  },
  _constructTurnBluffBreakevenPercentageData: function (state) {
    return {
      type: 'breakeven-percentage-for-bluffing-the-turn',
      storeState: state,
    };
  },
  _constructThreeBetCbetExplorerData: function (storeState) {
    let players = [];

    storeState.players.forEach(function (playerFromStore) {
      players.push({
        states: [{
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[0].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[0].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[0].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[0].generalHands.numberOfPossibleSpecificHands,
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[1].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[1].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[1].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[1].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[1].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[1].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[1].fiveCardHands),
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[2].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[2].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[2].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[2].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[2].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[2].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[2].fiveCardHands),
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[3].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[3].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[3].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[3].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[3].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[3].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[3].fiveCardHands),
        }],
      });
    }, this);

    return {
      type: 'three-bet-cbet-explorer',
      storeState: {
        players: players,
        presetCommunityCards: storeState.presetCommunityCards,
        openSize: storeState.openSize,
        threeBetSize: storeState.threeBetSize,
        numPlayersLeftToAct: storeState.numPlayersLeftToAct,
        averageFourBetPercentage: storeState.averageFourBetPercentage,
        cbetSize: storeState.cbetSize,
        continueVsCbetPercentage: storeState.continueVsCbetPercentage,
        hitPercentage: storeState.hitPercentage,
        firstStreetOfValuePercentage: storeState.firstStreetOfValuePercentage,
        secondStreetOfValuePercentage: storeState.secondStreetOfValuePercentage,
        thirdStreetOfValuePercentage: storeState.thirdStreetOfValuePercentage,
        alternativeEV: storeState.alternativeEV,
      },
    };
  },
  __getSpecificHandsInRange: function (generalHands) {
    let specificHandsInRange = [];

    generalHands.forEachSpecificHandInRange(function (specificHand) {
      specificHandsInRange.push(specificHand.string + '-' + specificHand.weight);
    });

    return specificHandsInRange;
  },
  __getSpecificHandStringsWithMaxPossibleWeightSet: function (generalHands) {
    let specificHandStringsWithMaxPossibleWeightSet = [];

    generalHands.forEachSpecificHand(function (specificHand) {
      if (specificHand.maxPossibleWeight < 100) {
        specificHandStringsWithMaxPossibleWeightSet.push(specificHand.string + '-' + specificHand.maxPossibleWeight);
      }
    });

    return specificHandStringsWithMaxPossibleWeightSet;
  },
  __getSpecificHandStringsThatAreManuallyAdded: function (generalHands) {
    let specificHandStringsThatAreManuallyAdded = [];

    generalHands.forEachPossibleSpecificHand(function (specificHand) {
      if (specificHand.manuallySet === 'added') {
        specificHandStringsThatAreManuallyAdded.push(specificHand.string);
      }
    });

    return specificHandStringsThatAreManuallyAdded;
  },
  __getSpecificHandStringsThatAreManuallyRemoved: function (generalHands) {
    let specificHandStringsThatAreManuallyRemoved = [];

    generalHands.forEachPossibleSpecificHand(function (specificHand) {
      if (specificHand.manuallySet === 'removed') {
        specificHandStringsThatAreManuallyRemoved.push(specificHand.string);
      }
    });

    return specificHandStringsThatAreManuallyRemoved;
  },
  __constructFiveCardHandsForServer: function (fiveCardHands) {
    let fiveCardHandsForServer = _.cloneDeep(fiveCardHands);

    utilities.general.forEachLeaf(fiveCardHandsForServer.madeHands.data, function (leaf) {
      delete leaf.id;
      delete leaf.text;
      delete leaf.fullText;
      delete leaf.inlineText;
      delete leaf.count;
      delete leaf.included;
      delete leaf._probability;
      delete leaf.level;
      delete leaf.madeHandDrawOrCombo;
      delete leaf.isAHit;
    });
    utilities.general.forEachParent(fiveCardHandsForServer.madeHands.data, function (parent) {
      delete parent.id;
      delete parent.text;
      delete parent.fullText;
      delete parent.inlineText;
      delete parent.count;
      delete parent._probability;
      delete parent.level;
      delete parent.isAHit;
    });
    utilities.general.forEachLeaf(fiveCardHandsForServer.draws.data, function (leaf) {
      delete leaf.id;
      delete leaf.text;
      delete leaf.fullText;
      delete leaf.inlineText;
      delete leaf.count;
      delete leaf.included;
      delete leaf._probability;
      delete leaf.level;
      delete leaf.madeHandDrawOrCombo;
      delete leaf.isAHit;
    });
    utilities.general.forEachParent(fiveCardHandsForServer.draws.data, function (parent) {
      delete parent.id;
      delete parent.text;
      delete parent.fullText;
      delete parent.inlineText;
      delete parent.count;
      delete parent._probability;
      delete parent.level;
      delete parent.isAHit;
    });
    utilities.general.forEachLeaf(fiveCardHandsForServer.combos.data, function (leaf) {
      delete leaf.id;
      delete leaf.text;
      delete leaf.fullText;
      delete leaf.inlineText;
      delete leaf.count;
      delete leaf.included;
      delete leaf._probability;
      delete leaf.level;
      delete leaf.madeHandDrawOrCombo;
      delete leaf.isAHit;
    });
    utilities.general.forEachParent(fiveCardHandsForServer.combos.data, function (parent) {
      delete parent.id;
      delete parent.text;
      delete parent.fullText;
      delete parent.inlineText;
      delete parent.count;
      delete parent._probability;
      delete parent.level;
      delete parent.isAHit;
    });

    return fiveCardHandsForServer;
  },
  __getGeneralHandStringColorMap: function (generalHands) {
    let generalHandStringColorMap = {
      green: [],
      blue: [],
      red: [],
      yellow: [],
      orange: [],
      purple: [],
      brown: [],
      impossible: [],
    };

    generalHands.forEach(function (generalHand) {
      if (generalHand.color === null) {
        return;
      }

      generalHandStringColorMap[generalHand.color].push(generalHand.string);
    });

    return generalHandStringColorMap;
  },
  __getGeneralHandStringEquityMap: function (generalHands) {
    let generalHandStringEquityMap = {};

    generalHands.forEach(function (generalHand) {
      generalHandStringEquityMap[generalHand.string] = generalHand.equity;
    });

    return generalHandStringEquityMap;
  },
  setEquityCalculatorStoreState: function (newStateFromServer, currentState) {
    this._setPresetCommunityCards(newStateFromServer, currentState);
    this._setEquityCalculatorPlayers(newStateFromServer, currentState);
    this._setEquityCalculatorPlayersEquityWinAndTie(newStateFromServer, currentState);
  },
  _setPresetCommunityCards: function (newStateFromServer, currentState) {
    currentState.presetCommunityCards.flop1 = newStateFromServer.presetCommunityCards.flop1 || null;
    currentState.presetCommunityCards.flop2 = newStateFromServer.presetCommunityCards.flop2 || null;
    currentState.presetCommunityCards.flop3 = newStateFromServer.presetCommunityCards.flop3 || null;
    currentState.presetCommunityCards.turn = newStateFromServer.presetCommunityCards.turn || null;
    currentState.presetCommunityCards.river = newStateFromServer.presetCommunityCards.river || null;
  },
  _setEquityCalculatorPlayers: function (newStateFromServer, currentState) {
    for (let i = 0; i < newStateFromServer.players.length; i++) {
      this.__setEquityCalculatorPlayer(newStateFromServer, currentState, i);
    }
  },
  __setEquityCalculatorPlayer: function (newStateFromServer, currentState, i) {
    let playerFromServer = newStateFromServer.players[i];
    let newPlayer = new Player();

    this.___setGeneralHands(
      newPlayer.states[0].generalHands,
      Number(playerFromServer.numberOfSpecificHandsInRange),
      Number(playerFromServer.numberOfPossibleSpecificHands),
      playerFromServer.specificHandsInRange,
      playerFromServer.specificHandStringsWithMaxPossibleWeightSet
    );
    Vue.set(currentState.players._players, i, newPlayer);
  },
  ___setGeneralHands: function (newGeneralHands, numberOfSpecificHandsInRange, numberOfPossibleSpecificHands, specificHandsInRange, specificHandStringsWithMaxPossibleWeightSet, specificHandStringsThatAreManuallyAdded, specificHandStringsThatAreManuallyRemoved) {
    newGeneralHands.numberOfSpecificHandsInRange = numberOfSpecificHandsInRange;
    newGeneralHands.numberOfPossibleSpecificHands = numberOfPossibleSpecificHands;

    if (specificHandStringsWithMaxPossibleWeightSet) {
      this.____setMaxPossibleWeights(newGeneralHands, specificHandStringsWithMaxPossibleWeightSet);
    }

    this.____setWeights(newGeneralHands, specificHandsInRange);

    if (specificHandStringsThatAreManuallyAdded || specificHandStringsThatAreManuallyRemoved) {
      this.____setManuallySet(newGeneralHands, specificHandStringsThatAreManuallyAdded, specificHandStringsThatAreManuallyRemoved);
    }
  },
  ____setWeights: function (newGeneralHands, specificHandsInRange) {
    if (!specificHandsInRange) return; // if empty array, db field is empty rather than holding an empty array

    specificHandsInRange.forEach(function (specificHandInRange) {
      let split = specificHandInRange.split('-');
      let specificHandString = split[0];
      let weight = Number(split[1]);
      let newSpecificHand = newGeneralHands.find(specificHandString);

      newSpecificHand.weight = weight;
    });
  },
  ____setMaxPossibleWeights: function (newGeneralHands, specificHandStringsWithMaxPossibleWeightSet) {
    newGeneralHands.forEachSpecificHand(function (newSpecificHand) {
      newSpecificHand.maxPossibleWeight = 100;
    });
    specificHandStringsWithMaxPossibleWeightSet.forEach(function (specificHandStringWithMaxPossibleWeight) {
      let split = specificHandStringWithMaxPossibleWeight.split('-');
      let specificHandString = split[0];
      let maxPossibleWeight = Number(split[1]);
      let newSpecificHand = newGeneralHands.find(specificHandString);

      newSpecificHand.maxPossibleWeight = maxPossibleWeight;
    });
  },
  ____setManuallySet: function (newGeneralHands, specificHandStringsThatAreManuallyAdded, specificHandStringsThatAreManuallyRemoved) {
    newGeneralHands.forEachSpecificHand(function (newSpecificHand, specificHandString) {
      if (specificHandStringsThatAreManuallyAdded && specificHandStringsThatAreManuallyAdded.includes(specificHandString)) {
        newSpecificHand.manuallySet = 'added';
      } else if (specificHandStringsThatAreManuallyRemoved && specificHandStringsThatAreManuallyRemoved.includes(specificHandString)) {
        newSpecificHand.manuallySet = 'removed';
      } else {
        newSpecificHand.manuallySet = false;
      }
    });
  },
  _setEquityCalculatorPlayersEquityWinAndTie: function (newStateFromServer, currentState) {
    for (let i = 0; i < newStateFromServer.players.length; i++) {
      currentState.players.find(i).states[0].equity = newStateFromServer.players[i].equity;
      currentState.players.find(i).states[0].winPercentage = newStateFromServer.players[i].winPercentage;
      currentState.players.find(i).states[0].tiePercentage = newStateFromServer.players[i].tiePercentage;
    }
  },
  setHitCalculatorStoreState: function (newStateFromServer, currentState) {
    this._setPresetHoleCards(newStateFromServer, currentState);
    this._setPresetCommunityCards(newStateFromServer, currentState);
    this._setHitCalculatorPlayers(newStateFromServer, currentState);
  },
  _setPresetHoleCards: function (newStateFromServer, currentState) {
    currentState.presetHoleCards.holeCardOne = newStateFromServer.presetHoleCards.holeCardOne;
    currentState.presetHoleCards.holeCardTwo = newStateFromServer.presetHoleCards.holeCardTwo;
  },
  _setHitCalculatorPlayers: function (newStateFromServer, currentState) {
    for (let i = 0; i < newStateFromServer.players.length; i++) {
      this.__setHitCalculatorPlayer(newStateFromServer, currentState, i);
    }
  },
  __setHitCalculatorPlayer: function (newStateFromServer, currentState, i) {
    let playerFromServer = newStateFromServer.players[i];
    let newPlayer = new Player();

    for (let j = 0; j < newPlayer.states.length; j++) {
      this.___setPlayerState(newPlayer.states[j], playerFromServer.states[j]);
    }

    Vue.set(currentState.players._players, i, newPlayer);
  },
  ___setPlayerState: function (newPlayerState, playerFromServerState) {
    if (newPlayerState.name === 'afterPreflop') {
      this.___setGeneralHands(
        newPlayerState.generalHands,
        Number(playerFromServerState.numberOfSpecificHandsInRange),
        Number(playerFromServerState.numberOfPossibleSpecificHands),
        playerFromServerState.specificHandsInRange,
        playerFromServerState.specificHandStringsWithMaxPossibleWeightSet
      );
    }

    else {
      this.___setGeneralHands(
        newPlayerState.generalHands,
        Number(playerFromServerState.numberOfSpecificHandsInRange),
        Number(playerFromServerState.numberOfPossibleSpecificHands),
        playerFromServerState.specificHandsInRange,
        playerFromServerState.specificHandStringsWithMaxPossibleWeightSet,
        playerFromServerState.specificHandStringsThatAreManuallyAdded,
        playerFromServerState.specificHandStringsThatAreManuallyRemoved
      );
      this.____setFiveCardHands(newPlayerState.fiveCardHands, playerFromServerState.fiveCardHands);
    }

    newPlayerState.equity = playerFromServerState.equity;
    newPlayerState.winPercentage = playerFromServerState.winPercentage;
    newPlayerState.tiePercentage = playerFromServerState.tiePercentage;
  },
  ____setFiveCardHands: function (newFiveCardHands, fiveCardHandsFromServer) {
    this._____setFiveCardHandsCategory(newFiveCardHands.madeHands, fiveCardHandsFromServer.madeHands);
    this._____setFiveCardHandsCategory(newFiveCardHands.draws, fiveCardHandsFromServer.draws);
    this._____setFiveCardHandsCategory(newFiveCardHands.combos, fiveCardHandsFromServer.combos);
  },
  _____setFiveCardHandsCategory: function (newFiveCardHandsOfCategory, fiveCardHandsOfCategoryFromServer) {
    newFiveCardHandsOfCategory.forEachLeaf(function (newFiveCardHandLeaf, indexes) {
      let fiveCardHandLeafFromServer = utilities.general.getArrayItemFromArrayOfIndexes(fiveCardHandsOfCategoryFromServer.data, indexes);

      newFiveCardHandLeaf.weight = Number(fiveCardHandLeafFromServer._weight);
    });
    newFiveCardHandsOfCategory.forEachParent(function (newMadeHandParent, indexes) {
      let madeHandParentFromServer = utilities.general.getArrayItemFromArrayOfIndexes(fiveCardHandsOfCategoryFromServer.data, indexes);

      newMadeHandParent.collapsed = madeHandParentFromServer.collapsed === true;
    });
  },
  setGuidedAnalysesBluffingStoreState: function (newStateFromServer, currentState) {
    this._setPresetHoleCards(newStateFromServer, currentState);
    this._setPresetCommunityCards(newStateFromServer, currentState);
    this._setGuidedAnalysesPlayers(newStateFromServer, currentState);
    currentState.streetToBluff = newStateFromServer.streetToBluff;
    currentState.bluffSize = newStateFromServer.bluffSize;
    currentState.profitableBreakevenPercentage = newStateFromServer.profitableBreakevenPercentage;
  },
  setGuidedAnalysesCallingStoreState: function (newStateFromServer, currentState) {
    this._setPresetHoleCards(newStateFromServer, currentState);
    this._setPresetCommunityCards(newStateFromServer, currentState);
    this._setGuidedAnalysesPlayers(newStateFromServer, currentState);
    currentState.streetToCall = newStateFromServer.streetToCall;
    currentState.potOdds = newStateFromServer.potOdds;
    currentState.realOddsLHS = newStateFromServer.realOddsLHS;
    this._setBettingCriteria(newStateFromServer, currentState);
  },
  _setGuidedAnalysesPlayers: function (newStateFromServer, currentState) {
    for (let i = 0; i < newStateFromServer.players.length; i++) {
      this.__setGuidedAnalysesPlayer(newStateFromServer, currentState, i);
    }
  },
  __setGuidedAnalysesPlayer: function (newStateFromServer, currentState, i) {
    let playerFromServer = newStateFromServer.players[i];
    let newPlayer = new Player();

    for (let j = 0; j < newPlayer.states.length; j++) {
      this.___setPlayerState(newPlayer.states[j], playerFromServer.states[j]);
    }

    Vue.set(currentState.players._players, i, newPlayer);
  },
  _setBettingCriteria: function (newStateFromServer, currentState) {
    if (!newStateFromServer.bettingCriteria) {
      return;
    }

    currentState.bettingCriteria = newStateFromServer.bettingCriteria;

    for (let flopTurnRiver in newStateFromServer.bettingCriteria) {
      for (let valueBetToBluffRatio in newStateFromServer.bettingCriteria[flopTurnRiver]) {
        newStateFromServer.bettingCriteria[flopTurnRiver][valueBetToBluffRatio].forEach(function (bettingCriterion) {
          if (bettingCriterion.equity === '') {
            bettingCriterion.equity = null;
          }
        });
      }
    }
  },
  setRangeConstructorStoreState: function (newStateFromServer, currentState) {
    currentState.actions = newStateFromServer.actions;
    this._setRangeConstructorGeneralHands(newStateFromServer, currentState);
  },
  _setRangeConstructorGeneralHands: function (newStateFromServer, currentState) {
    let newGeneralHands = new GeneralHands();
    let generalHand;

    for (let color in newStateFromServer.generalHandStringColorMap) {
      newStateFromServer.generalHandStringColorMap[color].forEach(function (generalHandString) {
        generalHand = newGeneralHands.find(generalHandString);
        generalHand.color = color;
        generalHand.forEachSpecificHand(function (specificHand) {
          specificHand.weight = 100;
        });
      });
    }

    Vue.set(currentState, 'generalHands', newGeneralHands);
  },
  setEquityMatrixStoreState: function (newStateFromServer, currentState) {
    currentState.requiredEquity = newStateFromServer.requiredEquity;
    this._setPresetCommunityCards(newStateFromServer, currentState);
    this._setEquityCalculatorPlayers(newStateFromServer, currentState);
    this._setResultGeneralHands(newStateFromServer.generalHandStringEquityMap, currentState.resultGeneralHands);
  },
  _setResultGeneralHands: function (generalHandStringEquityMap, resultGeneralHands) {
    resultGeneralHands.forEach(function (generalHand) {
      generalHand.equity = generalHandStringEquityMap[generalHand.string];
    });
  },
  setThreeBetCbetStoreState: function (newStateFromServer, currentState) {
    this._setGuidedAnalysesPlayers(newStateFromServer, currentState);
    this._setPresetCommunityCards(newStateFromServer, currentState);
    currentState.openSize = newStateFromServer.openSize;
    currentState.threeBetSize = newStateFromServer.threeBetSize;
    currentState.numPlayersLeftToAct = newStateFromServer.numPlayersLeftToAct;
    currentState.averageFourBetPercentage = newStateFromServer.averageFourBetPercentage;
    currentState.cbetSize = newStateFromServer.cbetSize;
    currentState.continueVsCbetPercentage = newStateFromServer.continueVsCbetPercentage;
    currentState.hitPercentage = newStateFromServer.hitPercentage;
    currentState.firstStreetOfValuePercentage = newStateFromServer.firstStreetOfValuePercentage;
    currentState.secondStreetOfValuePercentage = newStateFromServer.secondStreetOfValuePercentage;
    currentState.thirdStreetOfValuePercentage = newStateFromServer.thirdStreetOfValuePercentage;
    currentState.alternativeEV = newStateFromServer.alternativeEV;
  },
  setBreakevenPercentageForBluffingTheTurnStoreState: function (newStateFromServer, currentState) {
    currentState.turnPotSize = newStateFromServer.turnPotSize;
    currentState.turnBetSize = newStateFromServer.turnBetSize;
    currentState.numberOfOuts = newStateFromServer.numberOfOuts;
    currentState.percentageOfPotWonOnRiverWhenYouHitAnOut = newStateFromServer.percentageOfPotWonOnRiverWhenYouHitAnOut;
    currentState.numRiverCardsYoullBluff = newStateFromServer.numRiverCardsYoullBluff;
    currentState.riverBluffSize = newStateFromServer.riverBluffSize;
    currentState.probabilityOfGettingFoldOnRiver = newStateFromServer.probabilityOfGettingFoldOnRiver;
    currentState.position = newStateFromServer.position;
    currentState.probabilityThatOpponentBetsWhenYouCheck = newStateFromServer.probabilityThatOpponentBetsWhenYouCheck;
    currentState.checkCall = newStateFromServer.checkCall;
    currentState.opponentsTurnBetSize = newStateFromServer.opponentsTurnBetSize;
    currentState.percentageOfPotWonAfterCheckCall = newStateFromServer.percentageOfPotWonAfterCheckCall;
    currentState.percentageOfPotWonAfterTurnChecksThrough = newStateFromServer.percentageOfPotWonAfterTurnChecksThrough;
  },
};



// WEBPACK FOOTER //
// ./src/services/share-url-service.js